<div class="data-grid-container" [class.has-group-headers]="columnGroups?.length">
  <div class="table-container">
    <div class="table-scroll-wrapper" #tableScrollWrapper>
      <!-- Group Header Row -->
      @if (groupHeaderCells?.length) {
        <div class="group-header-row">
          @for (cell of groupHeaderCells; track cell) {
            <div class="group-header-cell"
              [class.group-header-cell--labeled]="cell.isGroup" [class.sticky-left-1]="cell.stickyLeft === 1"
              [class.sticky-left-2]="cell.stickyLeft === 2" [class.sticky-right]="cell.stickyRight"
              [style.flex]="cell.flex" [style.border-left]="cell.borderLeft ? '1px solid #dee2e6' : null"
              [style.border-right]="cell.borderRight ? '1px solid #dee2e6' : null">
              @if (cell.label) {
                <span>{{ cell.label }}</span>
              }
            </div>
          }
        </div>
      }
      <mat-table [dataSource]="dataSource" matSort (matSortChange)="onSortChange($event)"
        class="data-grid-table mat-elevation-2">
        <!-- Dynamic Columns -->
        @for (column of columns; track column) {
          <ng-container [matColumnDef]="column.key">
            <mat-header-cell *matHeaderCellDef
              [mat-sort-header]="column.sortable !== false && config.enableSorting ? column.key : null"
              [style.flex]="column.width ? '1 0 ' + column.width : '1'"
              [style.justify-content]="column.cellAlign === 'center' ? 'center' : ''"
              [ngClass]="getColumnClass(column.key)" [class.sticky-left-1]="column.key === 'appId'"
              [class.sticky-left-2]="column.key === 'name'"
              [class.sticky-right]="column.key === 'action' || column.key === 'actions'"
              [matTooltip]="column.tooltip || null" matTooltipPosition="above"
              matTooltipClass="multiline-tooltip">
              {{ column.label }}
            </mat-header-cell>
            <mat-cell *matCellDef="let item" [style.flex]="column.width ? '1 0 ' + column.width : '1'"
              [style.text-align]="column.cellAlign || ''"
              [style.justify-content]="column.cellAlign === 'center' ? 'center' : ''"
              [title]="column.cellTooltip ? '' : getColumnValue(item, column)"
              [matTooltip]="column.cellTooltip ? column.cellTooltip(item) : null"
              matTooltipClass="multiline-tooltip" matTooltipPosition="above"
              [ngClass]="getColumnClass(column.key)" [class.sticky-left-1]="column.key === 'appId'"
              [class.sticky-left-2]="column.key === 'name'"
              [class.sticky-right]="column.key === 'action' || column.key === 'actions'">
              <!-- Custom Template -->
              @if (column.customTemplate && !item.isFilterRow) {
                <ng-container
                *ngTemplateOutlet="column.customTemplate; context: { $implicit: item, column: column }"></ng-container>
              }
              <!-- Default Template -->
              @if (!column.customTemplate && !item.isFilterRow) {
                {{ getColumnValue(item, column) || '' }}
              }
            </mat-cell>
          </ng-container>
          } <!-- Actions Column -->
          @if (actions && actions.length > 0 && !hasActionColumn()) {
            <ng-container matColumnDef="actions">
              <mat-header-cell *matHeaderCellDef class="action-cell-header sticky-right">Actions</mat-header-cell>
              <mat-cell *matCellDef="let item" class="action-cell sticky-right">
                @for (action of actions; track action) {
                  @if (isActionVisible(action, item)) {
                    <button type="button"
                      [class]="getBootstrapButtonClass(action.color)"
                      [disabled]="isActionDisabled(action, item)" [title]="action.tooltip || action.label"
                      (click)="onActionClick(action, item, $event)" class="action-button me-1">
                      @if (action.icon) {
                        <i class="fa" [ngClass]="'fa-' + action.icon"></i>
                      }
                      {{ action.label }}
                    </button>
                  }
                }
              </mat-cell>
            </ng-container>
          }

          <!-- Filter Row Columns (if column filtering is enabled) -->
          @if (config.showColumnFilters) {
            @for (column of columns; track column) {
              <ng-container [matColumnDef]="column.key + '-filter'">
                <mat-cell *matCellDef [style.flex]="column.width ? '1 0 ' + column.width : '1'"
                  [class.sticky-left-1]="column.key === 'appId'" [class.sticky-left-2]="column.key === 'name'"
                  [class.sticky-right]="column.key === 'action' || column.key === 'actions'">
                  <!-- Multi-select dropdown filter (columns with known options) -->
                  @if (column.filterable !== false && filterOptions[column.key]?.length) {
                    <mat-select
                      multiple [value]="columnFilterSelections[column.key]" class="filter-select-dropdown"
                      panelClass="filter-dropdown-panel"
                      (selectionChange)="onMultiSelectFilterSelectionChange(column.key, $event.value)">
                      <mat-select-trigger>{{ getFilterTriggerLabel(column.key) }}</mat-select-trigger>
                      @for (opt of getSortedOptions(column.key); track opt) {
                        <mat-option [value]="opt">{{ opt
                        }}</mat-option>
                      }
                    </mat-select>
                  }
                  <!-- Text filter (columns without predefined options) -->
                  @if (column.filterable !== false && !filterOptions[column.key]?.length) {
                    <input type="text"
                      class="form-control form-control-sm filter-input"
                      [placeholder]="'Filter ' + column.label.toLowerCase() + '...'"
                      [(ngModel)]="columnFilters[column.key]"
                      (keyup.enter)="applyColumnFilter(column.key, columnFilters[column.key])"
                      (blur)="applyColumnFilter(column.key, columnFilters[column.key])">
                  }
                </mat-cell>
              </ng-container>
            }
            @if (actions && actions.length > 0) {
              <ng-container matColumnDef="actions-filter">
                <mat-cell *matCellDef class="action-filter-cell sticky-right">
                  <!-- Empty cell for actions column -->
                </mat-cell>
              </ng-container>
            }
          }

          <!-- Header and Row Definitions -->
          <mat-header-row *matHeaderRowDef="displayedColumns" [class.sticky-header]="config.stickyHeader"
          [style.top]="groupHeaderCells?.length ? '32px' : '0'"></mat-header-row>
          <!-- Filter Row (if column filtering is enabled) -->
          @if (config.showColumnFilters) {
            <mat-row *matRowDef="let row; columns: filterColumns; when: isFilterRow"
            class="filter-row"></mat-row>
          }

          <!-- Data Rows -->
          <mat-row *matRowDef="let row; columns: displayedColumns; when: isDataRow" class="data-row"
            [ngClass]="getRowClass(row)" [attr.data-id]="trackByItem(0, row)">
          </mat-row>

        </mat-table>

        <!-- Skeleton overlay — inside scroll wrapper so it scrolls horizontally with the table -->
        @if (loading) {
          <div class="table-loading-overlay" [style.top]="skeletonTopOffset">
            @for (row of skeletonRows; track row; let rowIndex = $index) {
              <div class="skl-loading-row">
                @for (col of skeletonColumns; track col.key; let colIndex = $index) {
                  <div class="skl-loading-cell"
                       [style.flex]="col.width ? '1 0 ' + col.width : '1'"
                       [class.sticky-left-1]="col.key === 'appId'"
                       [class.sticky-left-2]="col.key === 'name'"
                       [class.sticky-right]="col.key === 'action' || col.key === 'actions'"
                       [class.skl-loading-cell--actions]="col.key === 'action' || col.key === 'actions'">
                    @if (col.key !== 'action' && col.key !== 'actions') {
                      <div class="skl-loading-bar"
                           [style.width]="colIndex === 0 ? (rowIndex % 2 === 0 ? '74%' : '58%') : colIndex === 1 ? (rowIndex % 3 === 0 ? '48%' : '64%') : colIndex % 3 === 0 ? '46%' : rowIndex % 2 === 0 ? '62%' : '54%'">
                      </div>
                    } @else {
                      <div class="skl-loading-button-group">
                        <div class="skl-loading-bar" style="width: 44px; height: 28px; border-radius: 4px"></div>
                        <div class="skl-loading-bar" style="width: 56px; height: 28px; border-radius: 4px"></div>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }
      </div><!-- /.table-scroll-wrapper -->
      <!-- Empty state -->
      @if (!loading && totalItems === 0) {
        <div class="no-data-message">
          <mat-icon>search_off</mat-icon>
          <span>No applications found.</span>
        </div>
      }
    </div>
    <!-- Total Count -->
    @if (totalItems > 0) {
      <div class="total-count">
        Total: {{ totalItems }} items
      </div>
    }
    <!-- Hidden paginator (keeps data source binding) -->
    @if (config.pageSize) {
      <mat-paginator #paginator [pageSizeOptions]="config.pageSizeOptions || [5, 10, 25, 50, 100]"
        [pageSize]="config.pageSize || 25" (page)="onPageChange($event)" aria-label="Select page" style="display:none">
      </mat-paginator>
    }
    <!-- Custom Pagination -->
    @if (config.pageSize) {
      <div class="custom-paginator">
        <div class="items-per-page">
          <label for="pageSizeSelect">Items per page:</label>
          <select id="pageSizeSelect" (change)="onPageSizeChange($event)">
            @for (size of pageSizeOptions; track size) {
              <option [value]="size" [selected]="size === currentPageSize">{{
              size }}</option>
            }
          </select>
        </div>
        <div class="pagination">
          <button type="button" [class]="'icon-arrow-left' + (currentPageIndex === 0 ? ' aria-disabled' : '')"
            aria-label="Go to the previous page" [attr.aria-disabled]="currentPageIndex === 0 ? 'true' : null"
          (click)="prevPage()"></button>
          @for (page of pageNumbers; track page) {
            <button type="button"
              [class]="page === currentPageIndex + 1 ? 'aria-current' : ''" [attr.aria-label]="'Go to page ' + page"
              [attr.aria-current]="page === currentPageIndex + 1 ? 'true' : null" (click)="goToPage(page - 1)">{{ page
            }}</button>
          }
          <button type="button"
            [class]="'icon-arrow-right' + (currentPageIndex >= totalPages - 1 ? ' aria-disabled' : '')"
            aria-label="Go to the next page"
          [attr.aria-disabled]="currentPageIndex >= totalPages - 1 ? 'true' : null" (click)="nextPage()"></button>
        </div>
      </div>
      <br>
    }
  </div>